<cs-top-right-elements-m
    *ngIf="(moduleConfig$ | async).enableTopElements"
></cs-top-right-elements-m>

<cityscreen-mobile-header></cityscreen-mobile-header>

<div class="timeline-temp-wrapper" *ngIf="(currentGroup$ | async).id === 50">
    <div
        class="timeline__wrapper timeline__wrapper-displayFlex"
        [class.timeline__wrapper--mobile]="true"
    >
        <div
            class="timeline__top"
            [class.timeline-panel]="store.select(selectIsSidebarOpen) | async"
            [class.timeline-panel--mobile]="true"
        >
            <timeline-panel
                [aqiDataProvider]="aqiDataProvider"
                [isCityMode]="store.select(selectIsCityMode) | async"
                [currentTime]="store.select(selectPlumeTime) | async"
                [dates]="store.select(selectDatesPlumes) | async"
                [features]="store.select(selectSourcesAsFeatures) | async"
                [initSelectMeasurement]="store.select(currentPlumesMmt) | async"
                [labelMode]="true"
                [getDigitsAfterDot]="getDigits(store.select(selectMeasureScheme) | async)"
                [showNow]="true"
                [measureScheme]="store.select(selectMeasureScheme) | async"
                (goToCity)="goToCity($event)"
                (changeTimeIndex)="store.dispatch(updateTimeIndex({ payload: $event }))"
            >
            </timeline-panel>
        </div>
    </div>
</div>
